/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `Mobile.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { Mobile } from "./Mobile";

import { Audit } from "./Audit";
import { ContactMethodError } from "./ContactMethodError";
import { User } from "./User";

export abstract class MobileModel {
    id: number;
    createdAt: Dayjs;
    disabled: boolean;
    mobile: string | null;
    mobileType: string | null;
    receiveNotifications: boolean | null;
    updatedAt: Dayjs;
    userId: number | null;
    verificationCode: string | null;
    verified: boolean | null;
    audits: Audit[] | undefined;
    contactMethodErrors: ContactMethodError[] | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        disabled: boolean,
        mobile: string | null,
        mobileType: string | null,
        receiveNotifications: boolean | null,
        updatedAt: Dayjs,
        userId: number | null,
        verificationCode: string | null,
        verified: boolean | null,
        audits: Audit[] | undefined,
        contactMethodErrors: ContactMethodError[] | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.disabled = disabled;
        this.mobile = mobile;
        this.mobileType = mobileType;
        this.receiveNotifications = receiveNotifications;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.verificationCode = verificationCode;
        this.verified = verified;
        this.audits = audits;
        this.contactMethodErrors = contactMethodErrors;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): Mobile {
        const newObject = new Mobile(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["disabled"],
            json["mobile"],
            json["mobile_type"],
            json["receive_notifications"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["verification_code"],
            json["verified"],
            json["audits"]?.map((item: any) => Audit.fromApiObject(item, timezone)),
            json["contact_method_errors"]?.map((item: any) => ContactMethodError.fromApiObject(item, timezone)),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            disabled: this.disabled,
            mobile: this.mobile,
            mobile_type: this.mobileType,
            receive_notifications: this.receiveNotifications,
            updated_at: this.updatedAt,
            user_id: this.userId,
            verification_code: this.verificationCode,
            verified: this.verified,
            audits: this.audits?.map((item) => item.toApiObject()),
            contact_method_errors: this.contactMethodErrors?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): Mobile {
        const clone = Object.create(this) as Mobile;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
